import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context(
    './locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );

  const messages = {};
  locales.keys().forEach((key) => {
    const folder = key.match(/\.\/([a-z]+_*[A-Za-z]*)+\//i);
    if (folder && folder.length > 1) {
      const locale = folder[1];

      messages[locale] = messages[locale]
        ? { ...messages[locale], ...locales(key) }
        : { ...locales(key) };
    }
  });

  return messages;
}

const getSmartLocale = () => {
  const defaultLocale = 'es';
  const supportedLocales = ['es', 'en', 'pt_BR'];

  return localStorage.getItem('locale')
    ? supportedLocales.includes(localStorage.getItem('locale'))
      ? localStorage.getItem('locale')
      : defaultLocale
    : defaultLocale;
};

const i18n = new VueI18n({
  locale: getSmartLocale(),
  messages: loadLocaleMessages(),
});

export default i18n;
